import { useLangChecker } from '@common/utils/i18n';
import Button from '@stone/ui/button/Button';
import Icon from '@stone/ui/icon/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
const LoginOrRegisterHeader = (props) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "login-register-header" },
        React.createElement(Button, { cls: ['button--link'], type: "button", onClick: props.onBack },
            React.createElement(React.Fragment, null,
                React.createElement(Icon, { ariaHidden: true, family: "10", name: "left-chevron" }),
                React.createElement("span", { ref: useLangChecker }, t('label.sitename'))))));
};
export default LoginOrRegisterHeader;
